import React from "react";
import {
  FaPhone,
  FaWhatsapp,
  FaEnvelope,
  FaMapMarkerAlt,
  FaGlobe,
  FaShareAlt,
} from "react-icons/fa";
import logo from "./images/logo.jpg";
import image1 from "./images/image1.jpg";
import image2 from "./images/image2.jpg";
import image3 from "./images/image3.jpg";
import "./App.css";

const UnitedNutrition = () => {
  const handleLocationClick = () => {
    window.open(
      `https://www.google.com/maps/place/United+Nutrition/@22.7539094,75.8994171,17z/data=!3m1!4b1!4m6!3m5!1s0x39631d5502255555:0xdc412ae196cb76bb!8m2!3d22.7539094!4d75.901992!16s%2Fg%2F11bx4d5s3f?entry=ttu&g_ep=EgoyMDI1MDMwMy4wIKXMDSoASAFQAw%3D%3D`
    );
    window.open(
      `https://www.google.com/maps/place/United+Nutrition/@22.7539094,75.8994171,17z/data=!3m1!4b1!4m6!3m5!1s0x39631d5502255555:0xdc412ae196cb76bb!8m2!3d22.7539094!4d75.901992!16s%2Fg%2F11bx4d5s3f?entry=ttu&g_ep=EgoyMDI1MDMwMy4wIKXMDSoASAFQAw%3D%3D`
    );
  };

  return (
    <div className="container">
      <div className="header">
        <img src={logo} alt="United Nutrition" className="logo" />
        <p className="tagline">United Nutrition</p>
        <p className="tagline">
          🏋‍♂ United Nutrition – Fuel Your Fitness Journey! 💪
        </p>
      </div>

      <div className="button-bar">Click on buttons</div>

      <div className="icon-buttons">
        <button className="icon-button pink">
          <a href="tel:+919806118112">
            <FaPhone />
          </a>
        </button>
        <button className="icon-button green">
          <a
            href="https://api.whatsapp.com/send?phone=9806118112"
            // className="custom-btn secondary-btn"
          >
            <FaWhatsapp />
          </a>
        </button>
        <button className="icon-button yellow">
          <a href="https://mail.google.com/mail/u/0/?tab=rm&ogbl#inbox?compose=GTvVlcSDbSJXrxrqckkwfphbzvCrRLjgbJhMVNFGZzZCsVHMPbWJNXxlqbgMJcCpvNbzKtSZDkLSF">
            <FaEnvelope />
          </a>
        </button>
        <button className="icon-button blue" onClick={handleLocationClick}>
          <FaMapMarkerAlt />
        </button>
        <button className="icon-button purple">
          <FaGlobe />
        </button>
      </div>

      {/* <button className="qr-button">Scan QR Code</button> */}

      <div className="introduction-section">
        <h2 className="intro-title">Introduction</h2>
        <p className="intro-text">
          🔹 Founded by <strong>Mohit Ahuja | 10+ Years of Experience</strong>{" "}
          📍 2 Stores in Indore | 💯 Partnered with 100+ Gyms | 👥 Trusted by
          10,000+ Fitness Enthusiasts At United Nutrition, we provide
          top-quality sports supplements and fitness essentials to help you
          achieve your health goals. Whether you're a beginner, athlete, or
          bodybuilder, we have the perfect products to support your
          transformation. 🔥 Our Product Range: ✅ Premium Whey & Plant-Based
          Proteins ✅ High-Performance Creatine & BCAAs ✅ Energy-Boosting
          Pre-Workouts & Fat Burners ✅ Gym Accessories: Bags, Shakers, Belts &
          More ✅ Certified & Trusted Brands – 100% Authentic!
        </p>
      </div>

      <div className="projects-section">
        {/* <h2 className="projects-title">Key Projects</h2> */}
        <div className="projects-grid">
          <div className="project-card">
            <img
              src={image1} // Use the imported logo
              alt="Nutrition Fact"
              className="logo"
            />
            <p>
              <strong>Nutrition Facts</strong>
            </p>
          </div>
          <div className="project-card">
            <img
              src={image2} // Use the imported logo
              alt="Performance Whey"
              className="logo"
            />
            <p>
              <strong>Performance Whey</strong>
            </p>
          </div>
          <div className="project-card">
            <img
              src={image3} // Use the imported logo
              alt="Ingredients"
              className="logo"
            />
            <p>
              <strong>Ingredients</strong>
            </p>
          </div>
        </div>
        <button
          className="share-button"
          onClick={() =>
            navigator.share({
              title: "United Nutrition",
              text: "Check out this digital marketing agency!",
              url: window.location.href,
            })
          }
        >
          <FaShareAlt /> Share this card
        </button>
      </div>
    </div>
  );
};

export default UnitedNutrition;
